import { HEIGHT_MEASUREMENT } from 'productTemplate/enums/fitFeedback';

export enum FitFeedbackFormActions {
  resetForm = 'resetForm',
  setHeightMeasurement = 'setHeightMeasurement',
  setHeightCm = 'setHeightCm',
  setHeightFeet = 'setHeightFeet',
  setHeightInches = 'setHeightInches',
  setBodyShape = 'setBodyShape',
  setStyle = 'setStyle',
  setSizePurchased = 'setSizePurchased',
  setSizeFit = 'setSizeFit',
  setSneakersSizePurchased = 'setSneakersSizePurchased',
  setSneakersFit = 'setSneakersFit',
}

export interface IFitFeedbackApparelFormState {
  bodyShape: string | null;
  heightCm: string;
  heightFeet: string;
  heightInches: string;
  heightMeasurement: string;
  sizeFit: string | null;
  sizePurchased: string | null;
  style: string | null;
}

export const isApparelFormState = (
  formState: IFitFeedbackFormState,
): formState is IFitFeedbackApparelFormState => 'bodyShape' in formState;

export interface IFitFeedbackSneakersFormState {
  sneakersSizePurchased: string | null;
  sneakersFit: string | null;
}

export const isSneakersFormState = (
  formState: IFitFeedbackFormState,
): formState is IFitFeedbackSneakersFormState => 'sneakersFit' in formState;

export type IFitFeedbackFormState = IFitFeedbackApparelFormState | IFitFeedbackSneakersFormState;

export interface IFitFeedbackForm {
  type: FitFeedbackFormActions;
  payload?: string;
}

export const INITIAL_APPAREL_FIT_FEEDBACK_FORM_STATE: IFitFeedbackApparelFormState = {
  heightMeasurement: HEIGHT_MEASUREMENT.FT,
  heightCm: '',
  heightFeet: '',
  heightInches: '',
  bodyShape: null,
  style: null,
  sizePurchased: null,
  sizeFit: null,
};

export const INITIAL_SNEAKERS_FIT_FEEDBACK_FORM_STATE: IFitFeedbackSneakersFormState = {
  sneakersSizePurchased: null,
  sneakersFit: null,
};

export const fitFeedbackFormReducer = <T extends IFitFeedbackFormState>(
  state: T,
  action: IFitFeedbackForm,
) => {
  if (isApparelFormState(state)) {
    // Apparel form state
    switch (action.type) {
      case FitFeedbackFormActions.setHeightMeasurement: {
        state.heightMeasurement = action.payload;

        if (action.payload === HEIGHT_MEASUREMENT.FT) {
          state.heightCm = '';
        }
        if (action.payload === HEIGHT_MEASUREMENT.CM) {
          state.heightFeet = '';
          state.heightInches = '';
        }
        break;
      }
      case FitFeedbackFormActions.setHeightCm: {
        state.heightCm = action.payload;
        break;
      }
      case FitFeedbackFormActions.setHeightFeet: {
        state.heightFeet = action.payload;
        break;
      }
      case FitFeedbackFormActions.setHeightInches: {
        state.heightInches = action.payload;
        break;
      }
      case FitFeedbackFormActions.setBodyShape: {
        state.bodyShape = action.payload;
        break;
      }
      case FitFeedbackFormActions.setStyle: {
        state.style = action.payload;
        break;
      }
      case FitFeedbackFormActions.setSizePurchased: {
        state.sizePurchased = action.payload;
        break;
      }
      case FitFeedbackFormActions.setSizeFit: {
        state.sizeFit = action.payload;
        break;
      }
      case FitFeedbackFormActions.resetForm: {
        state.heightMeasurement = HEIGHT_MEASUREMENT.FT;
        state.heightCm = '';
        state.heightFeet = '';
        state.heightInches = '';
        state.bodyShape = null;
        state.style = null;
        state.sizePurchased = null;
        state.sizeFit = null;
        break;
      }

      default:
        return state;
    }
  } else {
    // Sneakers form state
    switch (action.type) {
      case FitFeedbackFormActions.setSneakersSizePurchased: {
        state.sneakersSizePurchased = action.payload;
        break;
      }
      case FitFeedbackFormActions.setSneakersFit: {
        state.sneakersFit = action.payload;
        break;
      }
      case FitFeedbackFormActions.resetForm: {
        state.sneakersSizePurchased = null;
        state.sneakersFit = null;
        break;
      }

      default:
        return state;
    }
  }
};
